import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private _router: Router,
    private _route: ActivatedRoute,
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this._router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe((e) => {
          window.scrollTo(0, 0);
        });
    }
  }
}
